<template>
  <div align="center" class="col s4" @click="detalhes()" style="height: 140px;">
    <img v-if="grupo.grupo.foto" :src="this.$store.state.url_files + 'grupos/' + grupo.grupo.foto" :alt="grupo.grupo.nome" class="circle responsive-img destaque" :style="' object-fit: cover;border-color: '+this.$store.state.empresa.cor_primaria"/>
    <img v-if="!grupo.grupo.foto" src="https://res.cloudinary.com/sirrus/image/upload/v1606569927/delivery/modas/assets/sem-foto_bbr18f.jpg" :alt="grupo.grupo.nome" class="circle responsive-img destaque" :style="'border-color: '+this.$store.state.empresa.cor_primaria"/>
    <div align="center">
      <strong style="font-size: x-small;font-weight: bold;z-index: 0;" class="waves-effect">{{grupo.grupo.nome}}</strong>
    </div>
  </div>
</template>

<script>
  import SecureLS from "secure-ls";
  export default {
    name: "Destaques",
    props:["grupo"],
    methods:{
      detalhes() {
        var ls = new SecureLS();
        ls.set('grupo',this.grupo);
        this.$router.push('/' + this.$store.state.empresa_url + '/menu/grupo/'+this.grupo.grupo.nome + '/secao/' + 0 )
      }
    }
  }
</script>

<style scoped>
.destaque{
  min-height: 80px;
  height: 80px;
  min-width: 80px;
  width: 80px;
  /*object-fit: scale-down;*/
  border-style:solid
}
</style>



// WEBPACK FOOTER //
// src/app/components/Destaques.vue